
<template>
  <app-layout class="resources-list-page-template">
    <Affix :offset-top="60">
      <Card shadow :padding="10" :style="{borderRadius: '0'}">
        <div class="ivu-input-wrapper ivu-input-type">
          <i class="ivu-icon ivu-icon-search ivu-input-icon ivu-input-icon-normal"></i>
          <input autocomplete="off" v-model="keyword" @keyup.13="searchGroup(keyword)" spellcheck="false" type="text" placeholder="Search..."
            class="ivu-input">
        </div>
      </Card>
    </Affix>
    <Row type="flex" justify="center">
      <Col :span="24" v-for="(item, k) in resource.groups.data.careplan" :key="k">
        <ResourceListItemComponent :item="item"></ResourceListItemComponent>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
import ResourceListItemComponent from '@/components/ResourceMainComponent'
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'

export default {
  name: 'ResourcesListComponent',
  mixins: [WindowScrollEvent],
  components: {
    ResourceListItemComponent
  },
  data () {
    return {
      keyword: null
    }
  },
  watch: {
    keyword: function (n, o) {
      if ('id' in this.profileInfo && !n) this.getResource(null)
    },
    $route: function (n, o) {
      // console.log('triggerd')
      this.getResource(null)
    }
  },
  computed: {
    profileInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    resource: {
      get () {
        return this.$store.state.resource.resources
      }
    },
    resourceType: {
      get () {
        return this.$route.query.type
      }
    }
  },
  methods: {
    getResource (k) {
      let query = ''

      // if(this.$route.query.type == 'special_project' || this.$route.query.type == 'marawi_rehabilitation'){
        query = 'group_id[]=' + this.profileInfo.country_id + '&group_id[]=1&section=group&type=' + this.resourceType
      // }else{
        // query = 'group_id[]=' + this.profileInfo.country_id + '&group_id[]=1&unpublish=1&section=group&access=public&is_approved=1'
      // }

      if (k) query += '&search=' + k
      this.$store.dispatch('resource/getResource', {
        type: 'groups',
        query
      })
    },
    searchGroup (k) {
      this.getResource(k)
    },
    onWindowScrolledBottom () {
      if (
        this.resource.groups.data.next_link &&
        !this.resource.groups.isLoading
      ) {
        this.$store.dispatch('resource/getResourceNextPage', {
          type: 'groups',
          url: this.resource.groups.data.next_link
        })
      }
    }
  },
  mounted () {
    this.getResource(null)
  }
}
</script>
